import { DictContext } from "@/layout/context/DictContext";
import { SConModal } from "@/styles/SConModal";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Flex, TableProps, Typography } from "antd";

import { Table } from "antd/lib";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import SText from "@/styles/SText";
import { WAddress } from "@/types/address";
import { addressDel } from "@/apis/address";
import AddressForm from "./AddressForm";
import { CurrencySelect } from "@/components/Selector";


const AddressManage: React.FC = () => {
  const { t } = useTranslation();
  const { Title } = Typography;

  const { addressData, setAddressData } = useContext(DictContext);
  const [detail, setDetail] = useState<WAddress | null>(null);
  const [addOpen, setAddOpen] = useState<boolean>(false);

  const columns: TableProps<WAddress>["columns"] = [
    {
      title: t("purchase.address"),
      dataIndex: "address",
      render: (value, record, index) => <SText text={value} />,
    },
    {
      title: t("purchase.currency"),
      dataIndex: "currency",
      width: 100,
      render: (_, item) => <CurrencySelect value={item.label1} readOnly />
    },
    {
      title: t("purchase.accer"),
      dataIndex: "receiver",
      render: (value, record, index) => <SText text={value} />,
    },
    {
      title: t("purchase.contact"),
      dataIndex: "contact",
      render: (value, record, index) => <SText text={value} />,
    },
    {
      title: t("purchase.phone1"),
      dataIndex: "mobile",
      render: (value, record, index) => <SText text={value} />,
    },
    {
      title: t("purchase.zipCode"),
      dataIndex: "zip",
      render: (value, record, index) => <SText text={value} />,
    },
    {
      title: t("common.opt"),
      width: 80,
      fixed: "right",
      render: (val, row) => <Flex>
        <Button type="link" icon={<EditOutlined size={10} />}
          onClick={(e) => { setDetail(row) }}
        />
        <SConModal
          children={
            <Button
              type="link"
              danger
              icon={<DeleteOutlined size={10} />}
            />
          }
          title={t("common.rmTip")}
          content={t("common.rmContent")}
          onOk={() =>
            addressDel(row.id ?? '').then(() => {
              setAddressData(addressData.filter(ads => ads.id !== row.id))
            })
          }
        ></SConModal>
      </Flex>
    }
  ];

  return <Flex vertical style={{ width: "100%" }} gap={10}>
    <Flex justify="space-between" align="baseline" style={{ marginTop: -20 }} >
      <Title level={4}>{t('layout.addressM')}</Title>
      <Button type="primary" onClick={() => setAddOpen(true)} >{t('common.add')}</Button>
    </Flex>
    <Table size="small" bordered dataSource={addressData}
      columns={columns} pagination={false}
      scroll={{ x: 800, y: 400 }}
    />
    {addOpen && <AddressForm formType="ADD" onOk={res => {
      setAddressData([res, ...addressData]);
      setAddOpen(false)
    }} onCancel={() => setAddOpen(false)} />}
    {detail && <AddressForm formType="EDIT" formData={detail} onOk={res => {
      setAddressData(addressData.map(a => a.id === res.id ? res : a));
      setDetail(null)
    }} onCancel={() => setDetail(null)} />}
  </Flex>
};

export default AddressManage;